
import * as React from "react"
import * as ReactDOM from "react-dom"
import * as Models from "../../generated_models"
import * as Api from '../../generated_api'
import * as Model from "../../generated_models"
import * as Immutable from 'immutable'
import { any, stateful, Action, string, unloadedAsyncState, loadingAsyncState, HttpResult, async, AsyncState, mk_widget, Widget, nothing, onlyIf, IOWidget } from "widgets-for-react";
import { FormData, FormState, DependenciesState, FieldId, DependencyResult, FieldData, DependencyId, IsMet } from "./types";
import { initializeIcons } from '@uifabric/icons';
import { FluentCustomizations } from '@uifabric/fluent-theme';
import { Stack, Text, Fabric, Customizer } from 'office-ui-fabric-react';
import { getFormState } from "./api";
import { form_renderer } from "./renderers";
import { get_dependency_result } from "./utils";
import { AsyncMonitor } from "./async_monitor";

initializeIcons();

export let Form : IOWidget<FormState, Action<FormState>> = (s0) => {
      let dependencies_async_list = Immutable.List<{ dep_res: { kind: "async", value: AsyncMonitor<IsMet> }, dep_id: DependencyId, field_id: FieldId }>()
      s0.dependencies_state.forEach((field_id__dep_res, dep_id) => {
        field_id__dep_res.forEach((dep_res, field_id) => {
          if (dep_res.kind == "async")
            dependencies_async_list = dependencies_async_list.push({ dep_id, field_id, dep_res })
        })
      })
      return (
        any<Action<FormState>>()(
          //we load the async dependencies
          dependencies_async_list.map((dep_elem, index) => {
            return dep_elem.dep_res.value.Widget.map<Action<FormState>>(a => s => {
              let s1 = s
              let a1 = a
              let field_id__dep_res = s.dependencies_state.get(dep_elem.dep_id).set(dep_elem.field_id, { kind: "async", value: a1 })
              return { ...s1, dependencies_state: s1.dependencies_state.set(dep_elem.dep_id, field_id__dep_res) }
            })
          }).toArray().concat([               
              //we load the form
              async<FormData>()(s0.form_data)
                .map<Action<FormState>>(a => state => {
                  let a1 = a(state.form_data)
                  let new_state = { ...state, form_data: a1 }
                  if (new_state.form_data.kind == "loaded") {
                    let all_fields: Immutable.Map<FieldId, FieldData> = Immutable.Map<FieldId, FieldData>()
                    new_state.form_data.value.steps.forEach(s => {
                      s.fields.forEach(f => {
                        all_fields = all_fields.set(f.Id, f)
                      })
                    })
                    let dependenciesState: DependenciesState = Immutable.Map()
                    new_state.form_data.value.steps.forEach(s => {
                      s.dependencies.forEach(d => {
                        let dependent_fields = Immutable.Map<FieldId, DependencyResult>()
                        d.dependent_fields.forEach(f => {
                          if (all_fields.has(f.FieldId)) {
                            let field_dep_state = dependent_fields.get(f.FieldId)
                            let dependency_result = get_dependency_result(f.FieldId, all_fields.get(f.FieldId).user_input, d.dependency,  field_dep_state && field_dep_state.kind == "async" ? field_dep_state.value : undefined)
                            if (dependency_result.kind == "simple" && dependency_result.value == false) {
                              dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                            }
                            else {
                              if (dependency_result.kind == "async") {
                                if (dependency_result.value.Result.kind == "loaded" && dependency_result.value.Result.value == false)
                                  dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                                else {
                                  if (dependency_result.value.Result.kind != "unloaded") {
                                    dependent_fields = dependent_fields.set(f.FieldId, dependency_result)
                                  }
                                }
                              }
                            }
                          }
                        })
                        dependenciesState = dependenciesState.set(d.dependency.Id, dependent_fields)
                      })
                    })
                    new_state.dependencies_state = dependenciesState
                  }
                  return new_state
                }),
              async<string>(null, {
                key : "submission form async",
                connectionError:string({readonly:true, readonly_element:"p", className:"message message--error"})("Probleem met verbinden").never(),                
                loading:(state => string({readonly:true, readonly_element:"p", className:"message"})("Formulier wordt verzonden").never()),
                unauthorizedError:string({readonly:true, readonly_element:"p", className:"message message--error"})("Geen toegang").never(),
                otherError:string({readonly:true, readonly_element:"p", className:"message message--error"})("Er is iets fout gegaan").never(),
                unloaded:null,
              })(s0.form_submission_logic)
                .map<Action<FormState>>(a => s => {
                  let a1 = a(s.form_submission_logic)
                  if(s.form_submission_logic.kind === 'loading' && a1.kind === 'loaded')  {
                    let s1 = getFormState([], s.form_data.kind === 'loaded' ? s.form_data.value.form.Id.toString() : '')
                    return {...s1,
                    form_submission_logic: a1,
                    context: s.context
                  }}
                  return {...s, form_submission_logic:a1}
                }),

              mk_widget({
                run: set_state => {
                  if (s0.form_data.kind != "loaded") return <p className="text-1 message">{s0.form_data.kind}</p>
                  return form_renderer(s0.form_data.value, s0, 
                              (new_form_submission_logic) => set_state(s => ({...s, form_submission_logic:new_form_submission_logic})),
                              (new_form, new_dependencies) => set_state(s => {
                                if (s.form_data.kind != "loaded") return s
                                return { ...s, form_data: { ...s.form_data, value: new_form }, dependencies_state: new_dependencies }
                              }))
                }
              })

            ]))
            ).wrapHTML(jsx => (
              <Fabric className="paragraph paragraph--form">
                <Customizer {...FluentCustomizations}>
                    {jsx}
                </Customizer>
              </Fabric>
            ))
            
        }